/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_content_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Long-form articles and guides.`)
};

const es_cat_content_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos extensos y guías.`)
};

const de_cat_content_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausführliche Artikel und Anleitungen.`)
};

const nl_cat_content_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgebreide artikelen en gidsen.`)
};

const fr_cat_content_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles de fond et guides.`)
};

const it_cat_content_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articoli lunghi e guide approfondite.`)
};

const pt_br2_cat_content_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artigos e guias completos.`)
};

const pt_cat_content_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artigos e guias longos.`)
};

const ja_cat_content_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長文の記事とガイド。`)
};

const zh_cat_content_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长篇文章与指南。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_content_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_content_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_content_desc", locale)
	if (locale === "en") return en_cat_content_desc(inputs)
	if (locale === "es") return es_cat_content_desc(inputs)
	if (locale === "de") return de_cat_content_desc(inputs)
	if (locale === "nl") return nl_cat_content_desc(inputs)
	if (locale === "fr") return fr_cat_content_desc(inputs)
	if (locale === "it") return it_cat_content_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_content_desc(inputs)
	if (locale === "pt") return pt_cat_content_desc(inputs)
	if (locale === "ja") return ja_cat_content_desc(inputs)
	return zh_cat_content_desc(inputs)
};